import { getScrollbarWidth, isBrowser } from '../utils';

/**
 * Этот хук запрещает скроллинг контента, скрывает скроллбар страниы
 * и добавляет конпенсирующий отступ справа, равный ширине скроллбара.
 * Однако фиксированные элементы, такие как шапка, могут "дергаться".
 * Чтобы этого не происходило, фиксированным элементам необходимо задавать
 * className="compensate-for-scrollbar", при этом фиксированные элементы не
 * должны иметь css-свойство width. Вместо width нужно использовать следующий
 * css-код для фиксируемых элементов:
 *
 * ```
 * .header {
 *   position: fixed;
 *   top: 0;
 *   left: 0;
 *   right: 0;
 * }
 * ```
 */

export function useCancelScrollPage() {
  const cancelScrollPage = () => {
    if (!isBrowser) return;

    const bodyEl = document.body;
    const bodyStyle = bodyEl.style;
    const compensateEl: NodeListOf<HTMLElement> = document.querySelectorAll(
      '.compensate-for-scrollbar'
    );

    if (bodyEl.clientWidth < window.innerWidth) {
      const scrollbarWidth = getScrollbarWidth();
      bodyStyle.paddingRight = `${scrollbarWidth}px`;
      compensateEl.forEach(el => (el.style.paddingRight = `${scrollbarWidth}px`));
    }

    /* не менять порядок top, left, right, position, иначе стрельнёт */
    bodyStyle.top = `-${window.scrollY}px`;
    bodyStyle.left = '0';
    bodyStyle.right = '0';
    bodyStyle.position = 'fixed';

    document.documentElement.style.overflow = 'hidden';
  };

  const restoreScrollPage = () => {
    if (!isBrowser) return;

    const bodyStyle = document.body.style;
    const scrollY = bodyStyle.top;
    const compensateEl: NodeListOf<HTMLElement> = document.querySelectorAll(
      '.compensate-for-scrollbar'
    );

    bodyStyle.position = '';
    bodyStyle.left = '';
    bodyStyle.right = '';
    bodyStyle.top = '';
    bodyStyle.paddingRight = '';

    compensateEl.forEach(el => (el.style.paddingRight = ''));
    document.documentElement.style.overflow = '';

    window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
  };

  return [cancelScrollPage, restoreScrollPage];
}
